// @flow
import * as React from 'react';
import { sprintf } from 'sprintf-js';
import Box from 'components/Box';
import { AvatarImage } from 'components/Image';
import { ConditionalLink } from 'components/Link';
import Text, { H4, Body } from 'components/Text';
import { humanDateTime } from 'utils/date';
import { colors } from 'theme';

const Byline = ({
  slug,
  name,
  imageHandle,
  homePageUrl,
  postedDate,
  showDate,
  small
}: {
  slug?: string,
  name?: string,
  imageHandle?: ?string,
  homePageUrl?: string,
  postedDate: string,
  showDate: boolean,
  small?: boolean
}) => (
  <Box classes={['flex', 'align-center']} data-qa-id="byline" flex="2">
    {imageHandle && (
      <AvatarImage
        data-qa-id="byline-image"
        alt={sprintf(getText('%(name)s profile image'), {
          name
        })}
        handle={imageHandle}
        width={60}
        round
        mr={16}
      />
    )}
    <Box>
      {name && (
        <H4 data-qa-id="author-name" m={0} lineHeight={1}>
          <ConditionalLink
            data-qa-id="author-name-link"
            link={
              homePageUrl && slug
                ? `/${homePageUrl}?author.slug=${slug}&searchMode=true&pq=`
                : ''
            }
          >
            <Body styleAs={small && 'bodySmall'} lineHeight={1.33}>
              {name}
            </Body>
          </ConditionalLink>
        </H4>
      )}
      {showDate && (
        <Text
          tag="time"
          dateTime={postedDate}
          color={colors.battleshipGrey}
          styleAs={small ? 'bodyMicro' : 'bodySmall'}
        >
          {humanDateTime(postedDate)}
        </Text>
      )}
    </Box>
  </Box>
);

export default Byline;
